import { useContext, useRef, useState } from 'react'
// import { ToDoListAdminProvider } from './ToDoListAdminProvider'
import { Check2Circle, Pen, Trash2, XCircle } from 'react-bootstrap-icons'
import { FaClone } from 'react-icons/fa'
import { useClickOutside } from '../../../../../components/Hooks/useClickOutside'
import CommonFunctionsContext from '../../../../common/CommonFunctionsProvider'

export default function TitleBarComponent({ title, container, className, onRemove, onEdit, cloneable, reference }) {
    const { GlobalRef, helpRefs, showConfirm } = useContext(CommonFunctionsContext)
    const [edit, setEdit] = useState(false)

    const ContainerRef = useRef()
    const ListNameRef = useRef()

    useClickOutside(ContainerRef, () => setEdit(false))

    const _handleClear = (e) => {
        if (e) e.stopPropagation()
        setEdit(false);
        document.removeEventListener('keyup', _handleKeyEvent);
    }

    const _handleKeyEvent = (e) => {
        switch (e.key) {
            case 'Escape': _handleClear(); break;
            case 'Enter': _handleSave(undefined); break;
            default: break;
        }
    }

    const _handleSave = async (e) => {
        if (!ListNameRef.current) return
        await onEdit(ListNameRef.current.value)
        _handleClear()
    }

    const _handleDelete = async (e) => {
        e.stopPropagation()
        await onRemove()
    }
    const _handleRename = async (e) => {
        if (e) {
            e.stopPropagation()
        }

        if (edit) {
            await _handleSave()
        } else {
            setTimeout(() => { ListNameRef.current.select() }, 200)
            ListNameRef.current.value = title

            document.addEventListener('keyup', _handleKeyEvent)
            setEdit(true)
        }
    }

    return (<>
        <button ref={ContainerRef} className={`title-bar ${className && className}`}>
            <div className='title-bar-title'>
                <div
                    ref={r => reference ?
                        r => GlobalRef(r, 'FacilityToDoListNewListItemItem') : undefined}
                    className={edit && 'd-none'}>{container}</div>
                <div className={!edit && 'd-none'}>
                    <input ref={ListNameRef} onClick={(e) => e.stopPropagation()} className='form-control form-control-sm' />
                </div>
            </div>
            <div className='title-bar-options'>
                {cloneable && <button className='btn btn-xs' onClick={cloneable.action}>
                    <FaClone />
                </button>}
                <button className='btn btn-xs' onClick={_handleRename}>
                    {edit ? <Check2Circle /> : <Pen />}
                </button>
                {edit ?
                    <button className='btn btn-xs' onClick={_handleClear}><XCircle /></button>
                    :
                    <button className='btn btn-xs' onClick={_handleDelete}><Trash2 /></button>
                }
            </div>
        </button >
    </>)
}